<template>
  <div>
    <b-card no-header>
      <form>
        <app-remito-estado
          label="Estado"
          :nombre="remitoEstadoNombre"
          :lista="remitosEstadosList"
          :label-cols="labelCols"
          labelOption="Seleccione un estado"
          @updated="remitoEstadoActualizado">
        </app-remito-estado>

        <b-form-group
          label="Fecha Despacho"
          label-for="fechaDespacho"
          :label-cols="labelCols">
          <b-input-group>
            <b-input-group-prepend is-text>
              <b-form-checkbox 
                  id="fechaDespachoHabilitada"
                  v-model="fechaDespachoHabilitada"
                  :value="true"
                  :unchecked-value="false">
              </b-form-checkbox>
            </b-input-group-prepend>
            <b-form-input 
              id="fechaDespacho" 
              v-model="fechaDespacho" 
              type="date"
              :disabled="fechaDespachoDisabled"
              :state="fechaDespachoValida">
            </b-form-input>
          </b-input-group>
          <b-form-invalid-feedback id="fechaDespachoFeedback">
            {{ fechaDespachoInvalidaMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          label="Entrega Estimada"
          label-for="fechaEntregaEstimada"
          :label-cols="labelCols">
          <b-input-group>
            <b-input-group-prepend is-text>
              <b-form-checkbox 
                  id="fechaEntregaEstimadaHabilitada"
                  v-model="fechaEntregaEstimadaHabilitada"
                  :value="true"
                  :unchecked-value="false">
              </b-form-checkbox>
            </b-input-group-prepend>
            <b-form-input 
              id="fechaEntregaEstimada" 
              v-model="fechaEntregaEstimada" 
              type="date"
              :disabled="fechaEntregaEstimadaDisabled"
              :state="fechaEntregaEstimadaValida">
            </b-form-input>
          </b-input-group>
          <b-form-invalid-feedback id="fechaEntregaEstimadaFeedback">
            {{ fechaEntregaEstimadaInvalidaMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>

        <b-form-group
          label="Fecha Entrega"
          label-for="fechaEntrega"
          :label-cols="labelCols">
          <b-input-group>
            <b-input-group-prepend is-text>
              <b-form-checkbox 
                  id="fechaEntregaHabilitada"
                  v-model="fechaEntregaHabilitada"
                  :value="true"
                  :unchecked-value="false">
              </b-form-checkbox>
            </b-input-group-prepend>
            <b-form-input 
              id="fechaEntrega" 
              v-model="fechaEntrega" 
              type="date"
              :disabled="fechaEntregaDisabled"
              :state="fechaEntregaValida">
            </b-form-input>
          </b-input-group>
          <b-form-invalid-feedback id="fechaEntregaFeedback">
            {{ fechaEntregaInvalidaMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </form>
      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Actualizar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </mensaje>
  </div>
</template>

<script>
import RemitoEstado from '../shared/abmSelect.vue';
import Mensaje from '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'

import { createHelpers } from 'vuex-map-fields';
const { mapFields } = createHelpers({
  getterType: 'remitoEstado/getField',
  mutationType: 'remitoEstado/updateField',
});

export default {
  name: 'RemitosActualizacionEstado',
  props: {
    remitoId: {
      type: Number,
      default: 0,
    },
    remitos: {
      type: Array,
      default: null,
    },
  },
  components: {
    appRemitoEstado: RemitoEstado,
    Mensaje
  },
  mixins: [ 
    msjModal 
  ],
  data () {
    return {
      fechaDespachoValida: null,
      fechaDespachoInvalidaMsj: '',
      fechaDespachoDisabled: true,
      fechaEntregaEstimadaValida: null,
      fechaEntregaEstimadaInvalidaMsj: '',
      fechaEntregaEstimadaDisabled: true,
      fechaEntregaValida: null,
      fechaEntregaInvalidaMsj: '',
      fechaEntregaDisabled: true,

      loadingEstados: false,
      remitosEstados: [],
      remitosEstadosList: [],
      labelCols: 3,
    }
  },
  computed: {
    ...mapFields([
      'remitoEstado',
      'remitoEstadoNombre',
      'fechaDespacho',
      'fechaDespachoHabilitada',
      'fechaEntregaEstimada',
      'fechaEntregaEstimadaHabilitada',
      'fechaEntrega',
      'fechaEntregaHabilitada'
    ]),
  },  
  created() {
    this.loadingEstados = true;
    this.$store.dispatch('remitoEstado/inicializar', this.remitoId)
      .then(() => this.getDatosAdicionales())
      .catch(error => this.showErrorMsj(error));
  },  
  methods: {
    getDatosAdicionales() {
      this.$store.dispatch('remitosEstados/getList')
        .then(() => {
          this.remitosEstados = this.$store.getters['remitosEstados/list'];
          this.remitosEstadosList = this.$store.getters['remitosEstados/selectList'];
          this.loadingEstados = false;
        })
    },    
    save () {
      let save = true;

      if (this.remitoEstadoId == 0) {
        this.showErrorMsj(new Error('Seleccione el estado del remito para completar la actualización'))
        save = false;
      }
      
      if (save) {
        this.showSpinner();
        this.$store.dispatch('remitoEstado/save')
          .then(() => this.showModalMsj('El estado del remito se actualizó con éxito', this.close, this.close, 'light'))
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    close() {
      this.$emit('close', true)
    },
    cancelar() {
      this.$emit('close', false)
    },
    remitoEstadoActualizado(remitoEstadoNombre) {
      if (!(/true/i).test(this.loadingEstados)) {
        let remitoEstado = null;
        if (remitoEstadoNombre) {
          remitoEstado = this.getSelected(this.remitosEstados, remitoEstadoNombre);
        }
  
        this.$store.dispatch('remitoEstado/setRemitoEstado', remitoEstado)
          .catch(error => this.showErrorMsj(error));
      }
    },
  },
  watch: {
    'fechaDespachoHabilitada' : function(newVal, oldVal) {
      this.fechaDespachoDisabled = !(/true/i).test(this.fechaDespachoHabilitada);
    },
    'fechaEntregaEstimadaHabilitada' : function(newVal, oldVal) {
      this.fechaEntregaEstimadaDisabled = !(/true/i).test(this.fechaEntregaEstimadaHabilitada);
    },
    'fechaEntregaHabilitada' : function(newVal, oldVal) {
      this.fechaEntregaDisabled = !(/true/i).test(this.fechaEntregaHabilitada);
    },            
  }    
}
</script>

<style>
</style>
